/*
*
* File JS componente Blocco Stadio
*
*/


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-stadio.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//



const blockStadio = () => {

    const context = document.querySelector('.block-stadio');
    if(!context) return;

    const headerTabs = context.querySelectorAll('.block-stadio__head > a');
    const contentTabs = context.querySelectorAll('.block-stadio__body > div');
    if(!headerTabs || !contentTabs) return;

    headerTabs.forEach(item => {

        item.addEventListener('click' , (e) => {
            e.preventDefault();
            const currentDatTab = item.getAttribute('data-tab');

            if(currentDatTab)  {
                const contentToShow = context.querySelector(`.block-stadio__content[data-tab='${currentDatTab}']`);
                toggleContentTabs(contentToShow);
                toggleHeader(item);
            }

        })

    });

    function toggleContentTabs(showTab) {
        contentTabs.forEach(item => {
          item.classList.remove('active');
          item.classList.remove('fade-in');          
        });
        showTab.classList.add('active');
        const startDiv = showTab.querySelector('.start');
        startDiv.classList.add('active');

        setTimeout(() => {
          showTab.classList.add('fade-in');
        }, 50); 
    }

    function toggleHeader(showHeader)
    {

        headerTabs.forEach(item => {
            item.setAttribute('aria-selected', 'false');
            item.classList.remove('active');
        });

        showHeader.classList.add('active');
        showHeader.setAttribute('aria-selected', 'true');
    }


    // MAP

    //Rinnovo:
    const mapRinnovo = context.querySelector('#stadium-rinnovo');
    const itemsRinnovo  = mapRinnovo.querySelectorAll('.item');
    const infoContainerRinnovo = mapRinnovo.querySelectorAll('.container-info__item');
    const backbuttonsRinnovo = mapRinnovo.querySelectorAll('.container-info__back-button');
    const overlayRinnovo = mapRinnovo.querySelector('.overlay');

    //Nuovo:
    const mapNuovo = context.querySelector('#stadium-nuovo');
    const itemsNuovo  = mapNuovo.querySelectorAll('.item');
    const infoContainerNuovo = mapNuovo.querySelectorAll('.container-info__item');
    const backbuttonsNuovo = mapNuovo.querySelectorAll('.container-info__back-button');
    const overlayNuovo = mapNuovo.querySelector('.overlay');
    
    itemsRinnovo.forEach(item => {
        item.addEventListener('click', e => {
            const valueMap = item.getAttribute('data-map-item'); 
            const containerInfoItem = mapRinnovo.querySelector(`.container-info__item[data-info='${valueMap}']`); 
            toggleMap(item);
            toggleContainerInfo(containerInfoItem, 'rinnovo');
        });
    });

    backbuttonsRinnovo.forEach(item => {
        item.addEventListener('click', e => {
            const containerInfoItem = mapRinnovo.querySelector(`.container-info__item[data-info='start']`); 
            toggleMap();
            toggleContainerInfo(containerInfoItem, 'rinnovo');
            overlayRinnovo.classList.remove('active');
        });
    });

    overlayRinnovo.addEventListener('click', e => {
        const containerInfoItem = mapRinnovo.querySelector(`.container-info__item[data-info='start']`); 
        toggleMap();
        toggleContainerInfo(containerInfoItem, 'rinnovo');
        overlayRinnovo.classList.remove('active');
        overlayNuovo.classList.remove('active');
    });

    
    itemsNuovo.forEach(item => {
        item.addEventListener('click', e => {
            const valueMap = item.getAttribute('data-map-item'); 
            const containerInfoItem = mapNuovo.querySelector(`.container-info__item[data-info='${valueMap}']`); 
            toggleMap(item);
            toggleContainerInfo(containerInfoItem, 'nuovo');
        });
    });

    backbuttonsNuovo.forEach(item => {
        item.addEventListener('click', e => {
            const containerInfoItem = mapNuovo.querySelector(`.container-info__item[data-info='start']`); 
            toggleMap();
            toggleContainerInfo(containerInfoItem, 'nuovo');
            overlayNuovo.classList.remove('active');
        });
    });

    overlayNuovo.addEventListener('click', e => {
        const containerInfoItem = mapNuovo.querySelector(`.container-info__item[data-info='start']`); 
        toggleMap();
        toggleContainerInfo(containerInfoItem, 'nuovo');
        overlayNuovo.classList.remove('active');
        overlayRinnovo.classList.remove('active');
    });


    function toggleContainerInfo(showContainer = null, type = '')
    {
        infoContainerNuovo.forEach(item => {
            item.classList.remove('active');
        });

        infoContainerRinnovo.forEach(item => {
            item.classList.remove('active');
        });

        if(showContainer)
        {
            showContainer.classList.add('active');
            if(type == 'nuovo')
            {
                overlayNuovo.classList.add('active');

            }else if ( type == 'rinnovo')
            {
                overlayRinnovo.classList.add('active');
            }

        }
    }

    function toggleMap(showMap = null)
    {
        itemsNuovo.forEach(item => {
            item.classList.remove('active');
        });

        itemsRinnovo.forEach(item => {
            item.classList.remove('active');
        });

        if(showMap)
        {
            showMap.classList.add('active');
        }
    }

}

export default blockStadio;

//--------------------------------------------------------------------//